/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_First_Name_HelpInputs */



/**
* | output |
* | --- |
* | "Enter the user's first name" |
*
* @param {Team_Manager_First_Name_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_first_name_help = /** @type {((inputs?: Team_Manager_First_Name_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_First_Name_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisissez le prénom de l’utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie den Vornamen des Benutzers ein")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci il nome dell'utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите имя пользователя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca el nombre del usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入用户的名字")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーの名を入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता का पहला नाम दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Digite o primeiro nome do usuário")
	return /** @type {LocalizedString} */ ("Enter the user's first name")
});